__turbopack_context__.v({
  "badLabel": "Yy8oqG_badLabel",
  "imgOverlay": "Yy8oqG_imgOverlay",
  "source": "Yy8oqG_source",
  "trash": "Yy8oqG_trash",
});
